module.exports = __webpack_public_path__ + "static/UnAmericanoaParigi-1a4c864ac42fa6ee43795c686f260b46.otf";